import { Card, DisplayText, Loading, Page, TextStyle } from '@shopify/polaris';
import React, { useCallback, useEffect } from 'react';
import wait from '../utils/wait';
import { createProject } from '../utils/woorankApi';
import { useProject } from './Providers/ProjectProvider';
import ReviewGenerationTips from '@hydra/common/components/ReviewGeneration/ReviewGenerationTips';
import { Translate } from '@hydra/common/components';

type ProjectGeneratorParams = {
  url: string;
  apiKey: string;
};

export default function ProjectGenerator ({
  url,
  apiKey
}: ProjectGeneratorParams) {
  const { project, refresh } = useProject();
  const [generationId, setGenerationId] = React.useState<null | string>(null);
  const startGeneration = useCallback(async () => {
    const res = await createProject(url, apiKey);
    if (res?.generation?.id) {
      setGenerationId(res?.generation?.id);
    }
    console.log(res);
  }, [url, apiKey]);

  const pollProject = useCallback(async () => {
    if (!project) {
      await wait(10000);
      return refresh();
    }
  }, [project, refresh]);

  useEffect(() => {
    startGeneration();
    pollProject();
  }, [startGeneration, pollProject]);

  return (
    <>
      <Loading />
      <Page>
        <Card sectioned>
          <Card.Header>
            <DisplayText>
              <h1>
                <Translate content='review_generation_title' component='span' />
                <TextStyle variation='strong'>
                  {url}
                </TextStyle>
              </h1>
            </DisplayText>
          </Card.Header>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ReviewGenerationTips />
          </div>
        </Card>
      </Page>
    </>
  );
}
